/**
 * Class Assignments Service (owner-only)
 *
 * Controls which classes an admin may see and act on. The server is the sole
 * authority — the frontend never sends its own scope. That matters: coach
 * scoping was previously done by the client passing its own id as a filter,
 * which any coach could simply drop to see everything.
 */

import apiClient from "../client";
import { API_ENDPOINTS } from "../../constants/api.constants";

const classAssignmentsService = {
  /** Classes currently assigned to one admin. */
  async listForUser(userId) {
    const { data } = await apiClient.get(API_ENDPOINTS.CLASS_ASSIGNMENTS.LIST, {
      params: { user_id: userId },
    });
    return data?.items || data || [];
  },

  /**
   * Replace an admin's entire assigned set.
   * Passing [] genuinely removes all access — it does not mean "unrestricted".
   */
  async replaceForUser(userId, classIds) {
    const { data } = await apiClient.put(
      API_ENDPOINTS.CLASS_ASSIGNMENTS.REPLACE(userId),
      { class_ids: classIds },
    );
    return data;
  },

  /** Admins in the organization, each with their current assignment count. */
  async assignableAdmins() {
    const { data } = await apiClient.get(
      API_ENDPOINTS.CLASS_ASSIGNMENTS.ASSIGNABLE_ADMINS,
    );
    return data?.items || data || [];
  },
};

export default classAssignmentsService;
